<div id="ato-imprimivel" [class]="ehVisaoRelacional() ? 'container-relacional' : 'container-visoes'">
    <div *ngIf="visaoAto">
        <header class="conteudo-nav">
            <div class="cabecalho-impressao">
               <a class="navbar-sistema"> 
                    <img class="logo-rfb" src="/assets/imagens/rfb/logo-rfb-azul.png" alt="Receita Federal">
                   <span class="sistema-nome">NORMAS</span>
               </a>
           </div>
        </header>
        <span class="titulo-visao"> Visão {{visaoAto.visao}}</span>
    </div>
    <div>
        <app-visualizar-ato 
            (visaoAtoEmitter)="obterVisaoAto($event)"
            [exibirDatasVigencia]="true"
        >
        </app-visualizar-ato>
    </div>
</div>